import React from "react";
import { useWauth } from "../auth/WauthProvider";
import styled from "styled-components";
import burgundyHomeBg from "../assets/backgrounds/home-burgundy-gold.webp";
import dreamsHomeBg from "../assets/backgrounds/Fondo-AppDreams-1.jpg";
import Button from "../components/atoms/Buttons";

const HomeBackground = styled.main`
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  background: #210605 url(${props => props.$image}) center / cover no-repeat;
`;

const WelcomeBackground = styled.section`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(620px, 100%);
  padding: clamp(32px, 4vw, 52px) clamp(24px, 4vw, 56px);
  background: linear-gradient(145deg, #450909ed, #280303dc 65%, #530c09e8);
  border: 1px solid #e8c36c;
  box-shadow: 0 22px 65px #0d0000a8, 0 0 20px #b9822326, inset 0 1px 0 #ffeab84a;
  border-radius: 38px;
  color: #fff0cb;
  font-family: Arial, sans-serif;
  text-align: center;
  @supports (backdrop-filter: blur(8px)) {
    background: linear-gradient(145deg, #450909bb, #280303aa 65%, #530c09c2);
    backdrop-filter: blur(8px);
  }
`
const HomeTitle = styled.h1`
  margin: 0;
  font: 800 clamp(36px, 3.35vw, 64px)/1.12 Arial, sans-serif;
  letter-spacing: -.04em;
  color: #ffe9a4;
  text-shadow: 0 1px #ffd875, 0 3px #b8791a, 0 5px #72300d, 0 8px 14px #280000;
`
const HomeSubtitle = styled.p`
  margin: 26px 0 32px;
  font: 400 clamp(18px, 1.65vw, 30px)/1.45 Arial, sans-serif;
  color: #fff0cb;
  text-shadow: 0 2px 7px #210000;
`
const EnterButton = styled(Button)`
  width: min(420px, 100%);
  min-height: 56px;
  padding: 18px 28px;
`;

const HomePage = () => {

  const { loginWithRedirect } = useWauth()

  let homeBackground = burgundyHomeBg

  if (window.location.host === 'dreams.sorteos.wargos.cloud') homeBackground = dreamsHomeBg

  return (
    <HomeBackground $image={homeBackground} data-testid="home-background">
      <WelcomeBackground aria-labelledby="home-title">
        <HomeTitle id="home-title">SORTEOS</HomeTitle>
        <HomeSubtitle>Bienvenido, aquí podrás<br />iniciar los sorteos.</HomeSubtitle>
        <EnterButton onClick={() => loginWithRedirect()}>INGRESAR</EnterButton>
      </WelcomeBackground>
    </HomeBackground>
  )
}

export default HomePage;
